import type { FC, ReactNode } from "react";
import React, { useState } from "react";

import type { Identity, UserId } from "@core/domains/identity";
import { bindArgs } from "@core/foundation/function";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@react/ui-primitives/dialog";

import { identityLabel } from "../../../shared/lib/identity.ts";

import { TopUpForm } from "./TopUpForm.tsx";

interface TopUpDialogProps {
  readonly activator: ReactNode;
  readonly identities: readonly Identity[];
  readonly principalId: UserId;
}

export const TopUpDialog: FC<TopUpDialogProps> = ({
  activator,
  identities,
  principalId,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>{activator}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Top Up Balance</DialogTitle>
          <DialogDescription>
            Add funds to {identityLabel(identities) || principalId}.
          </DialogDescription>
        </DialogHeader>
        <TopUpForm
          onSuccess={bindArgs(setOpen, false)}
          principalId={principalId}
        />
      </DialogContent>
    </Dialog>
  );
};
